//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  data() {
    return {};
  },
  props: {
    msg: { type: String, default: '' },
  },
  methods: {
    speed() {
      return `scrollTo linear ${Math.random() * 4 + 2}s infinite`;
    },
  },
};
